import {
    AccrualMatchAuditItem,
    AccrualMatchAuditItemType,
} from "@common/schemas/domains/accrualReview/accrual-match-audit-log.schema";
import { pluralize } from "@common/helpers/string";

/**
 * Builds a human-readable, comma-separated summary of the items matched
 * to a transaction in an accrual-match audit-log snapshot, e.g.
 * `"2 invoice lines, 1 bill line"` or `"1 transaction"`. Returns an empty
 * string when there are no items so callers can decide on a fallback noun.
 */
export function describeAccrualMatchItems(
    items: AccrualMatchAuditItem[],
): string {
    const counts = { invoice: 0, bill: 0, transaction: 0 };
    for (const item of items) {
        if (item.type === AccrualMatchAuditItemType.INVOICE_LINE_ITEM) {
            counts.invoice += 1;
        } else if (item.type === AccrualMatchAuditItemType.BILL_LINE_ITEM) {
            counts.bill += 1;
        } else if (item.type === AccrualMatchAuditItemType.TRANSACTION) {
            counts.transaction += 1;
        }
    }
    const parts: string[] = [];
    if (counts.invoice > 0) {
        parts.push(
            `${counts.invoice} invoice ${pluralize("line", counts.invoice)}`,
        );
    }
    if (counts.bill > 0) {
        parts.push(`${counts.bill} bill ${pluralize("line", counts.bill)}`);
    }
    if (counts.transaction > 0) {
        parts.push(
            `${counts.transaction} ${pluralize("transaction", counts.transaction)}`,
        );
    }
    return parts.join(", ");
}
